import React from 'react';
import { SidebarContainer, SidebarItem, SidebarSubItem } from './Guide.styles';
import { useTranslation } from '../../i18n';
import { GUIDE_SECTIONS } from './guideSections';

interface GuideSidebarProps {
  activeSection: string;
  onSectionClick: (id: string) => void;
}

export const GuideSidebar: React.FC<GuideSidebarProps> = ({ activeSection, onSectionClick }) => {
  const { t } = useTranslation();

  return (
    <SidebarContainer>
      {GUIDE_SECTIONS.map((section) => (
        <React.Fragment key={section.id}>
          <SidebarItem
            active={activeSection === section.id}
            onClick={() => onSectionClick(section.id)}
          >
            {t(section.labelKey)}
          </SidebarItem>
          {section.children?.map((child) => (
            <SidebarSubItem
              key={child.id}
              active={activeSection === child.id}
              onClick={() => onSectionClick(child.id)}
            >
              {t(child.labelKey)}
            </SidebarSubItem>
          ))}
        </React.Fragment>
      ))}
    </SidebarContainer>
  );
};
